import { createSelector } from '@ngrx/store';

import { selectMainSidebarState } from '../../_state';

export const selectIsMainSidebarExpanded = createSelector(selectMainSidebarState, state => state.isExpanded);
export const selectIsMainSidebarCollapsed = createSelector(selectIsMainSidebarExpanded, isExpanded => !isExpanded);
export const selectIsMainSidebarVisible = createSelector(selectMainSidebarState, state => state.isVisible);
export const selectIsMainSidebarHidden = createSelector(selectIsMainSidebarVisible, isVisible => !isVisible);
